module.exports = __webpack_public_path__ + "img/shuibiao.5650e84e.png";